import type { FaireProductEntity } from "../../entity_types/product";

export const p_m9hftqjqk7: FaireProductEntity = {
  token: "p_m9hftqjqk7",
  type: "product",
  name: "Cotton Black Stone Sun Moon Wide Leg Pant D1380",
  brandToken: "b_1ebsymwkg7",
  brandName: "Rising International Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/6dec09741076d175f40f1c8fbbe7258bb69b749d39406676c2ffad15be7b4169.jpeg",
  galleryImageUrls: [],
  priceDollars: 68,
  description:
    "Cotton Black Stone Sun Moon Wide Leg Pant from Rising International Inc, a brand that embodies Nepalese craftsmanship and sustainability. These pants are a unique blend of modern style and traditional heritage, handcrafted by local women artisans in Nepal. Made from eco-friendly cotton, these pants not only provide comfort but also contribute to environmental responsibility. Each pair showcases the talent of Nepalese artisans and reflects Rising International's commitment to sustainable practices. Enjoy a piece of Nepal's culture with these vibrant, patchwork pants.",
  tags: [],
  msrpDollars: 136,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:32.741Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
